// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-enter-active,.page-leave-active{transition:opacity .5s}.page-leave-active{transition-duration:.1s}.page-enter,.page-leave-to{opacity:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
